import { useMutation } from "react-query";
import { addType } from "../../../../actions/Utilities/BusinessLicensesPermitsType";
import { toast } from "components/toastNotification";
import { IBusLicensePermitType } from "../types";

const useAddType = () => {
  const { mutate } = useMutation(
    (NewData: IBusLicensePermitType) => addType(NewData),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Business License Permit Type Added Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Business License Permit Type Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Adding Business License Permit Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding Business License Permit Type failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire(
              "Adding Business License Permit Type failed ",
              `Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire(
              "Adding Business License Permit Type failed",
              res.Message,
              "error"
            );
        }
      },

      onError: (error: any) => {
        toast.fire(
          "Add Business License Permit Type failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
};
export default useAddType;
